import { OrderType } from 'types';

export const CANCEL_BDO_CARD_CONFIRMATION_COMMAND_TYPE = 'CancelBdoCardConfirmation';

export interface CancelBdoCardConfirmationCommand {
	orderId: number;
	orderType: OrderType;
}
